'use client';

import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { Badge } from '@sola/ark-core/atoms/badge/badge.js';
import {
  RadioGroupButtons,
  RadioGroupButtonsItem,
} from '@sola/ark-core/molecules/radio-group-buttons/radio-group-buttons.js';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.js';
import { PaymentMethodTypesEnum } from '@sola/schema/dotcom/supporters/paymentMethods.js';

interface PaymentMethodSwitchProps {
  setSelectedPaymentMethod: Dispatch<SetStateAction<PaymentMethodTypesEnum>>;
}

export const PaymentMethodSwitch = ({
  setSelectedPaymentMethod,
}: PaymentMethodSwitchProps) => {
  const { t } = useTranslation('my');
  return (
    <div>
      <RadioGroupButtons
        defaultValue={PaymentMethodTypesEnum.Ach}
        onChange={setSelectedPaymentMethod}
      >
        {/** Bank Button */}
        <RadioGroupButtonsItem value={PaymentMethodTypesEnum.Ach} id="ach">
          <span className="flex flex-col gap-snug-md">
            <ArkIcon iconName="bank" width="1.5rem" height="1.5rem" />
            <div className="flex gap-snug-lg">
              <Badge color="positive" label="Preferred" size="sm" />
            </div>
          </span>
        </RadioGroupButtonsItem>

        {/** Card Button */}
        <RadioGroupButtonsItem value={PaymentMethodTypesEnum.Card} id="card">
          <span className="flex flex-col gap-snug-md">
            <ArkIcon iconName="credit-card-02" width="1.5rem" height="1.5rem" />
            <div className="flex gap-snug-lg">
              {t('addPaymentMethod.switchLabels.card')}
            </div>
          </span>
        </RadioGroupButtonsItem>
      </RadioGroupButtons>
      <div />
    </div>
  );
};
